
import { FemsGraph, MasterGraph,BemsGraph } from "../../utility/apiURLS";
import Axios from '../data-access/genericAxios';
import ReArrangeLabel from "../../components/commoncomponents/ReArrangeLabel";
import { getFacilityId, getcompanyId } from '../../utility/tokenUtility';

async function getAssetNoForServiceChange(facilityId) {
      const response = await Axios.get(`${FemsGraph}/api/GraphFemsAssetregisterlist/GetAssetRegisterListFetch/${facilityId}?size=10000`);
      if (response?.status !== 'error') {            
            const reArrangedData = ReArrangeLabel(response?.data, "assetNo", "label");
            return reArrangedData;
      }
      return response;
    }
    async function getBemsAssetNoForServiceChange(facilityId) {
      const response = await Axios.get(`${BemsGraph}/api/GraphBemsAssetregisterlist/GetAssetRegisterListFetch/${facilityId}?size=10000`);
      if (response?.status !== 'error') {            
            const reArrangedData = ReArrangeLabel(response?.data, "assetNo", "label");
            return reArrangedData;
      }
      return response;
    }
    async function getTypeCodeForServiceChange(facilityId,companyId) {
      const response = await Axios.get(`${MasterGraph}/api/masters/GetMasters/${companyId}/${facilityId}?size=1000`);
  
      if (response?.status !== 'error') {
            const reArrangedData = ReArrangeLabel(response?.data?.masassettypecodes, "typecode", "label");
            return reArrangedData;
      }
      return response;
    }


    async function getAssetServiceChangeList(assetName,token) {
      const response = await Axios.get(`${BemsGraph}/api/Assetservicechange/AssetservicechangeList/${assetName}/${token}`);
      return response;
    }

    async function removeFemsService(AssetId,newServiceId,token) { 
      const response = await Axios.remove(`${FemsGraph}/api/Assetservicechange/DeleteExestingRecord/${AssetId}/${newServiceId}/${token}`); 
       return response;
     }
     
    async function removeBemsService(AssetId,newServiceId,token) { 
      const response = await Axios.remove(`${BemsGraph}/api/Assetservicechange/DeleteExestingRecord/${AssetId}/${newServiceId}/${token}`); 
       return response;
     }

     async function updateFemsService(values,AssetId) { 
      const response = await Axios.update(`${FemsGraph}/api/Assetservicechange/UpdateExestingRecord/${AssetId}`,values); 
  
       return response;
     }
     async function updateBemsService(values,AssetId) { 
      const response = await Axios.update(`${BemsGraph}/api/Assetservicechange/UpdateExestingRecord/${AssetId}`,values); 
  
       return response;
     }
     async function getFemsWoAffected(assetName) {
      const response = await Axios.get(`${FemsGraph}/api/Assetservicechange/AffectedWOList/${assetName}?size=1000`);

      return response;
    }
    async function getBemsWoAffected(assetName) {
      const response = await Axios.get(`${BemsGraph}/api/Assetservicechange/AffectedWOList/${assetName}?size=1000`);
      return response;
    }
    
async function postFemsAssetService(value) {
  const response = await Axios.post(`${FemsGraph}/api/femassetservicechanges`, value);
  return response;
}
async function postBemsAssetService(value) {
  const response = await Axios.post(`${BemsGraph}/api/bemassetservicechanges`, value);
  return response;
}


async function deleteFemsData(AssetId,workGroupId,token) { 
  const response = await Axios.remove(`${FemsGraph}/api/Assetservicechange/DeleteInternalTransferRecord/${AssetId}/${workGroupId}/${token}`); 
   return response;
 }

 async function deleteBemsData(AssetId,workGroupId,token) { 
  const response = await Axios.remove(`${BemsGraph}/api/Assetservicechange/DeleteInternalTransferRecord/${AssetId}/${workGroupId}/${token}`); 
   return response;
 }

    const assetServiceChangeRepository = {
      getAssetNoForServiceChange,
      getBemsAssetNoForServiceChange,
      getTypeCodeForServiceChange,
      getAssetServiceChangeList,
      removeFemsService,
      removeBemsService,
      updateFemsService,
      updateBemsService,
      getFemsWoAffected,
      getBemsWoAffected,
      postFemsAssetService,
      postBemsAssetService,
      deleteFemsData,
      deleteBemsData
    };
    
    
    export default assetServiceChangeRepository;